import React from 'react'

import { Button, Tooltip } from 'components/ds'

import { ADMIN_ONLY_MESSAGE, PRICING_PAGE_ERROR_MESSAGE } from './utils'

type Props = {
  /** Chargebee pricing page; until it arrives the button shows as loading */
  url?: string
  isAdmin: boolean
  /** The pricing page couldn't be loaded */
  disabled?: boolean
}

/** Links to the Chargebee pricing page in a new tab, where the subscription is changed. */
const ManageSubscriptionButton = ({
  url,
  isAdmin,
  disabled,
}: Props): React.ReactNode => {
  const label = 'Manage subscription'
  const isUsable = isAdmin && !disabled
  const isLink = isUsable && Boolean(url)

  const button = (
    <Button
      color="gray"
      highContrast
      size="2"
      asChild={isLink}
      loading={isUsable && !url}
      // Explicit, because passing false would override Radix's disabled-while-loading default
      disabled={isUsable && !url}
      // aria-disabled instead of disabled: a natively disabled button swallows the pointer events its tooltip needs
      aria-disabled={!isUsable || undefined}
      data-disabled={!isUsable || undefined}
    >
      {isLink ? (
        <a href={url} target="_blank" rel="noopener noreferrer">
          {label}
        </a>
      ) : (
        label
      )}
    </Button>
  )

  let tooltip: string | null = null
  if (!isAdmin) {
    tooltip = ADMIN_ONLY_MESSAGE
  } else if (disabled) {
    tooltip = PRICING_PAGE_ERROR_MESSAGE
  }

  return tooltip ? <Tooltip content={tooltip}>{button}</Tooltip> : button
}

export default ManageSubscriptionButton
